const BAND_IMAGE =
  "https://images.unsplash.com/photo-1769556669134-fe947b53bdbf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwyfHxnbG9iYWwlMjBmaW5hbmNpYWwlMjBtYXJrZXQlMjBza3lsaW5lfGVufDB8fHx8MTc5MjA1Nzc3M3ww&ixlib=rb-4.1.0&q=85";

export const CoverageBand = () => {
  return (
    <section data-testid="coverage-band" className="border-b border-grove-bsub">
      <div className="relative py-20 px-6 lg:px-12 overflow-hidden">
        <img
          src={BAND_IMAGE}
          alt="Global financial market skyline panorama"
          loading="lazy"
          className="absolute inset-0 w-full h-full object-cover eq-drift"
        />
        <div className="absolute inset-0 bg-[linear-gradient(150deg,rgba(17,40,30,0.88)_0%,rgba(8,28,21,0.92)_100%)]"></div>
        <div className="relative z-10 max-w-5xl mx-auto text-center text-white">
          <span className="font-mono text-xs uppercase tracking-widest text-emerald-300 mb-3 block">
            High Signal Analyst Workstation
          </span>
          <h2 className="font-disp text-3xl md:text-5xl font-normal leading-tight text-white mb-6">
            Eliminate manual data wrangling. Focus purely on high-conviction
            decision making.
          </h2>
          <p className="text-sm text-emerald-100 max-w-xl mx-auto">
            Designed for analysts who demand verified primary references with
            full traceability back to raw filings.
          </p>
        </div>
      </div>
    </section>
  );
};
